export * as Api from './api';

export enum WithdrawalStatus {
  Requested = 'REQUESTED',
  ExportedToCustodian = 'EXPORTED_TO_CUSTODIAN',
  Rejected = 'REJECTED',
  BulkUploaded = 'BULK_UPLOADED', // Display-only: show BulkUploaded when status is ExportedToCustodian and row is from bulk upload
}

export enum WithdrawalRequestSource {
  Investor = 'INVESTOR',
  AdminSite = 'ADMIN_SITE',
}

export enum WithdrawalExportStatus {
  AwaitingCustodianExport = 'AwaitingCustodianExport',
  ExportedToCustodian = 'ExportedToCustodian',
}
export interface ExportWithdrawal {
  _id: string;
  investorId: string;
  firmId: string;
  status: WithdrawalStatus;
  createdAt: Date;
  amount: number;
  withdrawalFee: number;
  requestSource: WithdrawalRequestSource;
  notes?: string;
  attachment?: string;
  attachmentSignedGetUrl?: string;
  investor: {
    _id: string;
    externalInvestorId?: string;
    fullName?: string;
    firstName?: string;
    lastName?: string;
    corporateName?: string;
    email?: string;
  };
  investorBankDetails: {
    bankAccountName?: string;
    bankAccountNumber?: string;
    bankSortCode?: string;
    iban?: string;
    swift?: string;
  };
  formattedExternalInvestmentIds: Array<string>;
  firm: {
    firmName?: string;
  };
}

export type ExportedWithdrawals = Array<
  Omit<ExportWithdrawal, 'formattedExternalInvestmentIds'> & {
    formattedExternalInvestmentIds: string;
  }
>;
